import Cookie from '../tools/Cookie';

export default class BodyPreference {
  constructor(selectSelector = 'select[name="nadwozie"]') {
    this.selectSelector = selectSelector;
    this.select = null;
  }

  init() {
    this.select = document.querySelector(this.selectSelector);
    if (!this.select) return false;

    // On change store cookie
    this.select.addEventListener('change', () => {
      if (this.select && this.select.value) {
        this.setPreferredBody(this.select.value);
      }
    });

    // If a value is preselected (e.g., pretty URL), set cookie on load
    const selected = this.select.value;
    if (selected) {
      this.setPreferredBody(selected);
    }

    return true;
  }

  setPreferredBody(value) {
    try {
      const cookie = new Cookie('preferred_body', value, 30);
      cookie.createCookie();
    } catch (e) {
      // Fallback if Cookie helper fails for any reason
      const date = new Date();
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = `preferred_body=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
    }
  }
}
